import { render } from "./header-block.vue?vue&type=template&id=d4f5200c"
import script from "./header-block.vue?vue&type=script&lang=js"
export * from "./header-block.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__